"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Copyright = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Copyright = exports.Copyright = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_index.Text, Object.assign({
    as: "small"
  }, props));
}).withConfig({
  displayName: "Copyright",
  componentId: "sc-15d7gge-0"
})(["padding-block-end:0;flex-shrink:0;"]);
var _default = exports["default"] = Copyright;